import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Card, Accordion, Spinner } from "react-bootstrap";
import { TextField, MenuItem } from "@mui/material";
import { ClockHistory } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import ApiOrderService from "../../../../../../core/api/api.ordersService";
import HistoryOfItemForDesktop from "../../../../Orders/components/HistoryOfItemForDesktop";
import HistoryOfTransactionsMobile from "../../../../Orders/components/BasketItems/operatorUpdatePersonItemsCanceled/HistoryOfTransactionsMobile";
import SaveIcon from "@mui/icons-material/SaveRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/CloseRounded";
import CheckIcon from "@mui/icons-material/Check";
import LogoutIcon from "@mui/icons-material/Logout";
import SwalMessage from "../../../../_Components/SwalMessage";
import { NumericFormat } from "react-number-format";
import Swal from "sweetalert2";
import SelectComponent from "../../../../_Components/ReactSelectComponent";
import ApiHome from "../../../../../../core/api/api.home";

function ModalUpdatePersonInItemsCanceled(props) {
  const [ordersServiceGetItem, setOrderServiceGetItem] = useState();
  const [ticketStatus, setTicketStatus] = useState([])
  const [inputList, setInputList] = useState([]);
  const [hasDeleteCancellation, setHasDeleteCancellation] = useState(false);
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: {} });
  const [listType, setListType] = useState([]);
  const [submitAndExit, setsubmitAndExit] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [cancelMessage, setCancelMessage] = useState(false);
  const [timeForSendCod, setTimeForSendCod] = useState(0); // timer for get agine cod
  const [showSupplierErrorMessage, setShowSupplierErrorMessage] = useState(false);
  const [initialStatus, setInitialStatus] = useState([])

  const fineAmountInputRef = useRef(null)
  const refundAmountInputRef = useRef(null)
  // set timer
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timeForSendCod > 0) {
        setTimeForSendCod(timeForSendCod - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  let showPrice = Intl.NumberFormat("en-US");
  const allStatusesRef = useRef([]);
  useEffect(() => {
    (async () => {
      try {
        const ticketStatusResponse = await ApiHome.getEnums({ enumName: "ReserveItemTicketSourceStatus" })
        setTicketStatus(ticketStatusResponse.data.map(item => ({ label: item.title, value: item.id })))
        // ------ تنظیم ورودی و دریافت لیست ایتم های کنسلی-----
        let selectedItemSTR = "";
        props.data.bascketPersons.forEach((item) => {
          selectedItemSTR += "ListBasketItemPersonID=" + item.id + "&";
        });
        // ارسال به سرور جهت دریافت جزییات ایتم های انتخابی
        const ordersServiceGetItem = await ApiOrderService.getItemWithDetails({
          basketId: props.data.basketId,
          listBasketItemPersonID: selectedItemSTR,
        });
        // اگر داده‌ها وجود ندارند یا نیاز به دریافت مجدد است
        if (
          props.data.typeOfModal === "CancelStatus" &&
          (listType.length <= 0 || allStatusesRef.current.length === 0)
        ) {
          const response = await ApiOrderService.GetEnumsName("BasketCancelStatus");
          allStatusesRef.current = response.data?.filter((a) => a.id !== 0 && a.id !== 1) || [];
        }
        const allStatuses = allStatusesRef.current; // دسترسی به داده‌های ذخیره شده
        // تکمیل فیلد های ورودی
        if (ordersServiceGetItem && ordersServiceGetItem.data && ordersServiceGetItem.data.length > 0) {
          setInputList(
            ordersServiceGetItem.data.map((item, index) => {
              setValue("status" + item.id, ticketStatusResponse.data.map(item => ({ label: item.title, value: item.id })).find(itemm => itemm.value == item.status));
              setInitialStatus(prev => [...prev, { id: item.id, status: item.status }])
              item.fineAmountIsLock = false; // بهتره تعریف شود عدم تعریف خطا نمی دهد
              //مقدار بازگشتی به کاربر
              const fineAmountNum = _.toInteger(item.fineAmount || 0);
              const paymentAmountNum = _.toInteger(item.rialPaymentAmount || 0);
              const refundAmount = paymentAmountNum - fineAmountNum > 0 ? paymentAmountNum - fineAmountNum : 0;
              item.refundAmount = refundAmount;
              const creditFineAmount = paymentAmountNum - fineAmountNum < 0 ? (fineAmountNum - paymentAmountNum) : 0
              setValue("refundAmount" + item.id, refundAmount);
              item.refundCreditAmount = _.toInteger(item.creditPaymentAmount) - creditFineAmount;
              setValue(
                "refundCreditAmount" + item.id,
                _.toInteger(item.creditPaymentAmount) - creditFineAmount,
              );
              if (item.fineAmount > 0) {
                item.fineAmountIsLock = true;
                item.fineAmount100IsLock = true;
                // مقدار دهی اولیه
                setValue("fineAmount" + item.id, item.fineAmount);
                setValue("fineAmount100" + item.id, _.toInteger((100 * item.fineAmount) / item.price));
                setValue("refundAmount" + item.id, refundAmount);
              }
              else if (item.cancelStatus != 5) {
                setValue("refundAmount" + item.id, refundAmount);
              }
              return item;
            }),
          );
        }
        setOrderServiceGetItem(ordersServiceGetItem);
        if (props.data.typeOfModal === "CancelStatus") {
          const initialStatus = ordersServiceGetItem.data[0].cancelStatus;
          var uniformity = ordersServiceGetItem.data.every(
            (item) => item.cancelStatus === initialStatus
          );
          if (!uniformity) {
            setListType([]);
            setShowSupplierErrorMessage(true);
            props.data.setStepCompleted((prev) => ({ ...prev, step2: false }));
          }
          else {
            if (initialStatus) {
              // فیلتر بر اساس وضعیت اولیه
              let filteredStatuses = [];
              switch (initialStatus) {
                case 1:
                  filteredStatuses = allStatuses.filter((a) => a.id === 2);
                  props.data.setStepCompleted((prev) => ({ ...prev, step2: false }));
                  break;
                case 2:
                  filteredStatuses = allStatuses.filter((a) => a.id !== 2);
                  props.data.setStepCompleted((prev) => ({ ...prev, step2: false }));
                  break;
                case 3:
                  filteredStatuses = allStatuses.filter((a) => a.id === 2);
                  props.data.setStepCompleted((prev) => ({ ...prev, step2: false }));
                  break;
                case 4:
                case 5:
                  filteredStatuses = [];
                  props.data.setStepCompleted((prev) => ({ ...prev, step2: true }));
                  break;
                default:
                  filteredStatuses = allStatuses;
              }
              setListType(filteredStatuses);
            }
          }
        }
        else {
          const cancelStatus = ordersServiceGetItem.data.some((item) => item.cancelStatus === 4);
          if (cancelStatus) {
            setHasDeleteCancellation(true);
            props.data.setStepCompleted((prev) => ({ ...prev, deleteStep1: false }));
          } else {
            setHasDeleteCancellation(false);
            props.data.setStepCompleted((prev) => ({ ...prev, deleteStep1: true }));
          }
        }
        // ---------
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, [refreshPage]);

  let lastService = "";
  function showService(item) {
    if (lastService != item.basketItemAmusementServiceName) {
      lastService = item.basketItemAmusementServiceName;
      return (
        <Row className="mt-5">
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
          <Col xs="auto">
            <h5 className="text-center">{item.basketItemAmusementServiceName}{item.hallEventTitle && ` - ${item.hallEventTitle}`}</h5>{" "}
          </Col>
          <Col>
            <hr style={{ borderTop: "3px solid #484848" }} />
          </Col>
        </Row>
      );
    }
  }

  function inputOnChange(value, inputType, inputItem, changeInGroup) {
    //// value // مقدار تغییر یافته جدید
    //// inputType  // نوع فایل که تشخیص دهیم کدام ستون است
    //// inputItem // ایتم یا سطر انتخاب شده
    //// changeInGroup // در صورت فعال شدن تنها در گروه خودش اعمال تغییر می کند
    //// isLock // عنوان متغییری که تکست باکس را قفل میکند تا در صورت تغییر هدر تغییر نکند
    const isLock = inputType + "IsLock";
    // ----  ویرایش ایتم  -----
    inputItem[isLock] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
    inputItem[inputType] = value;
    setValue(inputType + inputItem.id, value);
    // اگر در حال تغییر مبلغ جریمه این ایتم هستیم درصد هم باید تعییر کند
    if (inputType === "fineAmount") {
      inputItem[inputType + "100" + "IsLock"] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
      inputItem[inputType + "100"] =
        _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / inputItem.price);
      setValue(
        inputType + "100" + inputItem.id,
        "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / inputItem.price),
      );
    } // و برعکس
    if (inputType === "fineAmount100") {
      inputItem["fineAmountIsLock"] = true; // قفل کردن ایتم که توسط هدر در اینده تغییر نکند
      inputItem["fineAmount"] = "" + _.toInteger((inputItem.price * _.toInteger(value.replaceAll("درصد", ""))) / 100);
      setValue(
        "fineAmount" + inputItem.id,
        "" + _.toInteger((inputItem.price * _.toInteger(value.replaceAll("درصد", ""))) / 100),
      );
    }
    if (inputType == "refundAmount") {
      if (inputItem["rialPaymentAmount"] - _.toInteger((`${inputItem.fineAmount ?? 0}`).replaceAll(",", "")) > _.toInteger(value.replaceAll(",", ""))) {
        inputItem.refundCreditAmount = _.toInteger(inputItem.creditPaymentAmount + inputItem["rialPaymentAmount"] - _.toInteger((`${inputItem.fineAmount ?? 0}`).replaceAll(",", "")) - _.toInteger(value.replaceAll(",", "")));
        setValue(
          "refundCreditAmount" + inputItem.id,
          _.toInteger(inputItem.creditPaymentAmount + inputItem["rialPaymentAmount"] - _.toInteger((`${inputItem.fineAmount ?? 0}`).replaceAll(",", "")) - _.toInteger(value.replaceAll(",", ""))),
        );
      }
      inputItem.refundAmount = +value?.replaceAll(",", "");
      setValue("refundAmount" + inputItem.id, +value?.replaceAll(",", ""));
      return
    }
    //مقدار بازگشتی به کاربر
    const fineAmountNum = _.toInteger((`${inputItem.fineAmount ?? 0}`)?.replaceAll(",", "") || 0);
    const paymentAmountNum = _.toInteger(inputItem.rialPaymentAmount || 0);
    const refundAmount = paymentAmountNum - fineAmountNum > 0 ? paymentAmountNum - fineAmountNum : 0;
    const creditFineAmount = paymentAmountNum - fineAmountNum < 0 ? (fineAmountNum - paymentAmountNum) : 0
    inputItem.refundAmount = refundAmount;
    setValue("refundAmount" + inputItem.id, refundAmount);
    setValue(
      "refundCreditAmount" + inputItem.id,
      _.toInteger(inputItem.creditPaymentAmount) - creditFineAmount,
    );
    setValue(
      "creditFineAmount" + inputItem.id,
      creditFineAmount,
    );
    // ایا ایتم در اول گروه قرار دارد ؟ تغییر بقیه ایتم ها
    let changeItemList = [];
    if (inputList.length > 0) {
      if (changeInGroup) {
        // اعمال تغییر در گروه خودش تنها صورت پذیرد اگر در ابتدای لیست
        let currentGroupList = inputList.filter(function (item) {
          return item.basketItemId == inputItem.basketItemId;
        });
        if (currentGroupList.length > 0 && currentGroupList[0].id == inputItem.id) changeItemList = currentGroupList;
      } else {
        // اعمال تغییر در تمام لیست صورت پذیرد اگر در ابتدای لیست
        if (inputList[0].id == inputItem.id) changeItemList = inputList;
      }
    }
    // تغییر ایتم های دیگر مجموعه
    if (changeItemList.length > 0) {
      changeItemList.map((item) => {
        if (!item[isLock]) {
          item[inputType] = value;
          setValue(inputType + item.id, value);
          // اگر در حال تغییر مبلغ جریمه این ایتم هستیم درصد هم باید تغییر کند
          if (inputType === "fineAmount") {
            item["fineAmount100"] = "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / item.price);
            setValue(
              "fineAmount100" + item.id,
              "" + _.toInteger((100 * _.toInteger(value.replaceAll(",", ""))) / item.price),
            );
            setValue("refundAmount" + item.id, refundAmount);
          } // و برعکس
          if (inputType === "fineAmount100") {
            item["fineAmount"] = "" + _.toInteger((item.price * _.toInteger(value.replaceAll("درصد", ""))) / 100);
            setValue(
              "fineAmount" + item.id,
              "" + _.toInteger((item.price * _.toInteger(value.replaceAll("درصد", ""))) / 100),
            );
            setValue("refundAmount" + item.id, refundAmount);
          }
        }
        item.creditFineAmount = creditFineAmount;
        item.refundCreditAmount = _.toInteger(item.creditPaymentAmount) - creditFineAmount;
        setValue(
          "refundCreditAmount" + item.id,
          _.toInteger(item.creditPaymentAmount) - creditFineAmount,
        );
        setValue(
          "creditFineAmount" + item.id,
          creditFineAmount,
        );
      });
    }
  }
  const onSubmit = async (data) => {
    try {
      if (props.data.typeOfModal === "CancelStatus" && (!_.isNumber(data.canceledstatus?.value) || data.canceledstatus?.value <= 0)) {
        SwalMessage({ title: "لطفا وضعیت کنسلی را انتخاب نمایید.", iSsuccess: false });
        return;
      }
      let basketId = props.data.basketId ? parseInt(props.data.basketId) : 0;
      let resApiData = {};
      if (props.data.typeOfModal === "DeleteOprationCancelStatus") {
        Swal.fire({
          title: "حذف فرایند ",
          text: "درخواست در وضعیت کنسل شده هست، آیا قصد حذف عملیات انجام شده را دارید؟",
          icon: "question",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          cancelButtonText: "انصراف",
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap btn btn-secondary",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            resApiData = await ApiOrderService.deleteCancellationOperation({
              basketId: basketId,
              listBasketItemPersons: props.data.bascketPersons.map((item) => {
                return {
                  basketItemPersonId: item.id,
                };
              }),
            });
            SwalMessage({ title: resApiData.message, iSsuccess: resApiData.succeeded });
            if (resApiData.succeeded) {
              setRefreshPage(!refreshPage);
              props.data.callBack();
            }
          }
        });
      } else {
        let result = {
          basketId: basketId,
          cancelStatus: props.data.typeOfModal === "CancelStatus" ? data.canceledstatus?.value : null,
          listBasketItemPersons: inputList.map((item) => {
            let fineAmount = item.fineAmount.length > 0 ? item.fineAmount.replaceAll(",", "") : item.fineAmount;
            fineAmount = _.toInteger(fineAmount) ? _.toInteger(fineAmount) : 0;
            return {
              basketItemPersonId: item.id,
              fineAmount,
              rialAmount: item.refundAmount ?? 0,
              creditAmount: item.refundCreditAmount ?? 0,
              status: item.status
            };
          }),
          description: data.description,
        };
        if (props.data.typeOfModal === "CancelStatus")
          resApiData = await ApiOrderService.changeBasketItemPersonCancelStatus(result);
        else resApiData = await ApiOrderService.updateBasketItemPersonFineAmount(result);
        SwalMessage({ title: resApiData.message, iSsuccess: resApiData.succeeded });
        if (resApiData.succeeded) {
          if (!submitAndExit) {
            setRefreshPage(!refreshPage);
          }
          props.data.callBack();
        }
      }
    } catch (error) {
    } finally {
    }
  };

  const handleCancelStatusChange = (event) => {
    const selectedValue = event?.value;

    // زمانی که گزینه خاص انتخاب شد، پیام را نمایش می‌دهیم
    if (selectedValue === 4) {
      setCancelMessage(true);
      setTimeForSendCod(8);
    } else {
      setCancelMessage(false);
      setTimeForSendCod(0);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {ordersServiceGetItem && ordersServiceGetItem.succeeded ? (
          <div>
            <Row>
              <Col xs="12">
                {props.data.typeOfModal === "CancelStatus" && listType.length > 0 && (
                  <Row className="align-items-center justify-content-center">
                    <Col xs="12" sm="7" lg="4">
                      <Controller
                        name="canceledstatus"
                        control={control}
                        render={({ field: { value, onChange }, fieldState: { error } }) => (
                          <>
                            <SelectComponent
                              className="w-100 mt-5"
                              placeholder="انتخاب وضعیت"
                              options={listType.map((item) => ({
                                value: item.id,
                                label: item.title,
                                color: item.id == 4 ? "red" : ""
                              }))}
                              variant="outlined"
                              margin="normal"
                              size="small"
                              value={value || ""}
                              onChange={(e) => {
                                onChange(e); // برای مدیریت تغییرات فیلد
                                handleCancelStatusChange(e); // برای نشان دادن پیام
                              }}
                            />
                            {error && <p style={{ color: "red" }}>{error.message}</p>}
                          </>
                        )}
                      />
                    </Col>
                  </Row>
                )}
                {ordersServiceGetItem &&
                  ordersServiceGetItem.data &&
                  ordersServiceGetItem.data.map((item, index) => {
                    return (
                      <div key={index}>
                        {showService(item)}
                        <Card className="my-4">
                          <Card.Body style={{ backgroundColor: index % 2 == 0 && "rgba(0,0,0,0.013)" }} className="p-4">
                            <Accordion>
                              <Row>
                                <Col xs="auto" className="my-auto">
                                  <Accordion.Header className="custom-acc-button" variant="link">
                                    <ClockHistory color="#767885" size={15} />
                                  </Accordion.Header>
                                </Col>
                                <Col className="flex-grow-1">
                                  <Row
                                    className="mt-2 align-items-center  mb-5 pb-5 mb-xl-0 pb-xl-0"
                                  >
                                    <Col xs="12" sm="4" lg="3" style={{ maxWidth: isMobile ? "100%" : 260 }} className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label={item.hallBlockName ? "صندلی" : "نام"}
                                        value={item.hallBlockName ? `جایگاه: ${item.hallBlockName} - ردیف: ${item.hallRowName} - صندلی: ${item.hallSeatName}` : item.personFullName}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="3" xl className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label="کنسلی کاربر"
                                        value={item.cancelStatusS}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="3" xl className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label="مبلغ آیتم"
                                        value={`${showPrice.format(item.price)}تومان`}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="3" xl className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label=" پرداختی کاربر"
                                        value={`${showPrice.format(item.paymentAmount)}تومان`}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="3" xl className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label="پرداخت به تامین کننده"
                                        value={`${showPrice.format(item.payToWarantyAmount)}تومان`}
                                      />
                                    </Col>
                                    <Col xs="12" sm="4" lg="3" xl className="px-1 mt-5">
                                      <TextField
                                        disabled
                                        fullWidth
                                        variant="outlined"
                                        label="دریافت از تامین کننده"
                                        value={`${showPrice.format(item.receiveOfWarantyAmount)}تومان`}
                                      />
                                    </Col>
                                  </Row>
                                  <Row
                                    className="mt-2 justify-content-between align-items-center mt-5 pb-5 mb-xl-0 pb-xl-0"
                                  >
                                    <Col xs="12" sm="auto" className="flex-grow-1 justify-content-end mt-5" style={{ maxWidth: "fit-content" }}>
                                      <Row className="items-box gap-3 p-4">
                                        <div style={{ fontSize: 12, backgroundColor: "#fcfcfc", width: "fit-content" }} className="items-box-header fw-bold">
                                          بازگشتی به کاربر
                                            </div>
                                        <Col xs="12" sm="4" lg="3" style={{ maxWidth: isMobile ? "100%" : 260 }} className="px-1">
                                          <Controller
                                            name={"fineAmount" + item.id}
                                            control={control}
                                            render={({ field: { onChange, value, ref } }) => (
                                              <NumericFormat
                                                disabled={!(props.data.typeOfModal === "CancelStatus" && listType.length > 0)}
                                                customInput={TextField}
                                                name={"fineAmount" + item.id}
                                                sx={{
                                                  "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                      borderColor: "black", // رنگ حاشیه
                                                    },
                                                  },
                                                }}
                                                inputRef={(el) => {
                                                  ref(el)
                                                  fineAmountInputRef.current = el
                                                }}
                                                size="small"
                                                type="search"
                                                value={value || ""}
                                                className={
                                                  errors["fineAmount" + item.id]
                                                    ? "border border-danger form-control text-center"
                                                    : "text-center form-control"
                                                }
                                                variant="outlined"
                                                thousandSeparator=","
                                                decimalScale="."
                                                isAllowed={({ floatValue }) => {
                                                  // اگر قفل فعال است و عدد جدید از max بیشتر است، ورود را ممنوع کن
                                                  if (floatValue !== undefined && floatValue > item.paymentAmount) {
                                                    onChange(item.paymentAmount);
                                                    requestAnimationFrame(() => {
                                                      setTimeout(() => {
                                                        fineAmountInputRef.current?.setSelectionRange(
                                                          fineAmountInputRef.current.value?.length,
                                                          fineAmountInputRef.current.value?.length
                                                        )
                                                      }, 0)
                                                    })
                                                    return false;
                                                  }
                                                  return true;
                                                }}
                                                onChange={(event) => {
                                                  inputOnChange(event.target.value, "fineAmount", item, true)
                                                }}
                                                placeholder="جریمه کاربر"
                                                label="جریمه کاربر"
                                                onKeyDown={(e) => {
                                                  if (e.key === "Escape") {
                                                    e.stopPropagation()
                                                  }
                                                }}
                                              />
                                            )}
                                          />
                                        </Col>
                                        <Col xs="12" sm="4" lg="3" style={{ maxWidth: isMobile ? "100%" : 192 }} className="px-1">
                                          <Controller
                                            name={"fineAmount100" + item.id}
                                            control={control}
                                            render={({ field: { onChange, value } }) => (
                                              <NumericFormat
                                                disabled={!(props.data.typeOfModal === "CancelStatus" && listType.length > 0)}
                                                customInput={TextField}
                                                name={"fineAmount100" + item.id}
                                                size="small"
                                                value={value || ""}
                                                className="text-center form-control"
                                                variant="outlined"
                                                sx={{
                                                  "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                      borderColor: "black", // رنگ حاشیه
                                                    },
                                                  },
                                                }}
                                                decimalScale="."
                                                type="search"
                                                suffix=" درصد  "
                                                isAllowed={({ floatValue }) => floatValue !== undefined && floatValue <= 100}
                                                onChange={(event) =>
                                                  inputOnChange(event.target.value, "fineAmount100", item, true)
                                                }
                                                placeholder=" درصد جریمه کاربر "
                                                label=" درصد جریمه کاربر "
                                                onKeyDown={(e) => {
                                                  if (e.key === "Escape") {
                                                    e.stopPropagation()
                                                  }
                                                }}
                                              />
                                            )}
                                          />
                                        </Col>
                                        <Col xs="12" sm="4" lg="3" style={{ maxWidth: isMobile ? "100%" : 190 }} className="px-1">
                                          {!(props.data.typeOfModal === "CancelStatus" && listType.length > 0) ?
                                            <TextField
                                              disabled
                                              variant="outlined"
                                              fullWidth
                                              label="بازگشتی به کیف پول نقدی کاربر"
                                              value={`${showPrice.format(item.rialRefundAmount || 0)} تومان`}
                                            />
                                            : <Controller
                                              name={"refundAmount" + item.id}
                                              control={control}
                                              render={({ field: { value, onChange, ref } }) => (
                                                item.rialPaymentAmount == 0 ? <TextField
                                                  disabled
                                                  fullWidth
                                                  variant="outlined"
                                                  label="بازگشتی به کیف پول نقدی کاربر"
                                                  value="خرید کاملا اعتباری بوده"
                                                /> : <NumericFormat
                                                  disabled={!(props.data.typeOfModal === "CancelStatus" && listType.length > 0) || item.rialPaymentAmount == 0}
                                                  customInput={TextField}
                                                  name={"refundAmount" + item.id}
                                                  sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                      "& fieldset": {
                                                        borderColor: "black", // رنگ حاشیه
                                                      },
                                                    },
                                                  }}
                                                  inputRef={(el) => {
                                                    ref(el)
                                                    refundAmountInputRef.current = el
                                                  }}
                                                  size="small"
                                                  type="search"
                                                  value={value || ""}
                                                  className={
                                                    errors["refundAmount" + item.id]
                                                      ? "border border-danger form-control text-center"
                                                      : "text-center form-control"
                                                  }
                                                  variant="outlined"
                                                  thousandSeparator=","
                                                  decimalScale="."
                                                  isAllowed={({ floatValue }) => {
                                                    // اگر قفل فعال است و عدد جدید از max بیشتر است، ورود را ممنوع کن
                                                    if (floatValue !== undefined && floatValue > item.rialPaymentAmount - _.toInteger((`${item.fineAmount ?? 0}`).replaceAll(",", ""))) {
                                                      onChange(item.rialPaymentAmount - _.toInteger((`${item.fineAmount ?? 0}`).replaceAll(",", "")) > 0 ? item.rialPaymentAmount - _.toInteger((`${item.fineAmount ?? 0}`).replaceAll(",", "")) : 0);
                                                      setValue(
                                                        "refundCreditAmount" + item.id,
                                                        _.toInteger(item.creditPaymentAmount) - _.toInteger(item.creditFineAmount),
                                                      );
                                                      requestAnimationFrame(() => {
                                                        setTimeout(() => {
                                                          refundAmountInputRef.current?.setSelectionRange(
                                                            refundAmountInputRef.current.value?.length,
                                                            refundAmountInputRef.current.value?.length
                                                          )
                                                        }, 0)
                                                      })
                                                      return false;
                                                    }
                                                    return true;
                                                  }}
                                                  onChange={(event) => {
                                                    inputOnChange(event.target.value, "refundAmount", item, true)
                                                  }}
                                                  placeholder="بازگشتی به کیف پول نقدی کاربر"
                                                  label="بازگشتی به کیف پول نقدی کاربر"
                                                  onKeyDown={(e) => {
                                                    if (e.key === "Escape") {
                                                      e.stopPropagation()
                                                    }
                                                  }}
                                                />
                                              )}
                                            />}
                                        </Col>
                                        <Col xs="12" sm="4" lg="3" style={{ maxWidth: isMobile ? "100%" : 190 }} className="px-1">
                                          {!(props.data.typeOfModal === "CancelStatus" && listType.length > 0) ?
                                            <TextField
                                              disabled
                                              variant="outlined"
                                              fullWidth
                                              label="بازگشتی به کیف پول اعتباری کاربر"
                                              value={`${showPrice.format(item.creditRefundAmount || 0)} تومان`}
                                            />
                                            : <Controller
                                              name={"refundCreditAmount" + item.id}
                                              control={control}
                                              render={({ field: { value } }) => (
                                                <TextField
                                                  disabled
                                                  variant="outlined"
                                                  fullWidth
                                                  label="بازگشتی به کیف پول اعتباری کاربر"
                                                  value={`${showPrice.format(value || 0)} تومان`}
                                                />
                                              )}
                                            />}
                                        </Col>
                                      </Row>
                                    </Col>
                                    {!(props.data.typeOfModal === "CancelStatus" && listType.length > 0) &&
                                      <Col xs="12" sm="auto" className="flex-grow-1 justify-content-end mt-5" style={{ maxWidth: "fit-content" }}>
                                        <Row className="items-box gap-3 p-4">
                                          <div style={{ fontSize: 12, backgroundColor: "#fcfcfc", width: "fit-content" }} className="items-box-header fw-bold">
                                            پرداختی کاربر
                                            </div>
                                          <Col style={{ maxWidth: isMobile ? "100%" : "10vw" }} className="p-0">
                                            <TextField
                                              disabled
                                              variant="outlined"
                                              label="نقدی"
                                              value={`${showPrice.format(item.rialPaymentAmount || 0)} تومان`}
                                            />
                                          </Col>
                                          <Col style={{ maxWidth: isMobile ? "100%" : "10vw" }} className="p-0">
                                            <TextField
                                              disabled
                                              variant="outlined"
                                              label="اعتباری"
                                              value={`${showPrice.format(item.creditPaymentAmount || 0)} تومان`}
                                            />
                                          </Col>
                                        </Row>
                                      </Col>}
                                    {(props.data.typeOfModal === "CancelStatus" && listType.length > 0) && !!item.amusementServiceReserveItemTicketSourceId &&
                                      <Col xs="12" sm="auto" className="flex-grow-1 px-2">
                                        <Controller
                                          name={"status" + item.id}
                                          control={control}
                                          render={({ field, fieldState }) => (
                                            <SelectComponent
                                              className="mt-5"
                                              placeholder="وضعیت منبع بلیط"
                                              options={ticketStatus.filter(itemm => itemm.value == initialStatus[index].status || itemm.value == 2 || itemm.value == 1)}
                                              field={field}
                                              onChange={(e) => {
                                                field.onChange(e)
                                                item.status = e?.value
                                              }}
                                            />
                                          )}
                                        />
                                      </Col>}
                                  </Row>
                                </Col>
                                {props.data.typeOfModal !== "DeleteOprationCancelStatus" && (
                                  <Col style={{ height: "inherit" }} xs="12" sm="4" lg="1" className="px-1 text-small-1 text-center">
                                    {item.cancelStatus === 4 || item.cancelStatus === 5 ? (
                                      <div className="text-success bg-light-success rounded-2 p-1 h-100 d-flex flex-column justify-content-center">
                                        <div>
                                          <CheckIcon /> کنسلی کاربر
                                      </div>
                                        <div>تکمیل شد</div>
                                      </div>
                                    ) : (
                                      <div className="text-warning bg-light-warning rounded-2 p-1 h-100 d-flex flex-column justify-content-center">
                                        <div>
                                          <CloseIcon /> کنسلی کاربر
                                      </div>
                                        <div>کامل نشده است</div>
                                      </div>
                                    )}
                                  </Col>
                                )}
                              </Row>
                              <Accordion.Body className="px-0 pt-0">
                                {/* typeS: "پرداخت_به_گارانتی_کننده" */}
                                <div className="px-0 pt-0 pt-xl-4">
                                  {isMobile ? (
                                    <HistoryOfTransactionsMobile item={item} itemtransactions={item.transactions} typeOfModalWaranty={props.data.typeOfModal} />
                                  ) : (
                                    <HistoryOfItemForDesktop item={item} itemtransactions={item.transactions} typeOfModalWaranty={props.data.typeOfModal} />
                                  )}
                                </div>
                              </Accordion.Body>
                            </Accordion>
                          </Card.Body>
                        </Card>
                      </div>
                    );
                  })}
                <Row>
                  <Col xs="12" sm="12" lg="12" className="px-1">
                    <Controller
                      name="description"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          id="description"
                          className="w-100 mt-2"
                          variant="outlined"
                          type="text"
                          rows={4}
                          multiline
                          disabled={!(props.data.typeOfModal === "CancelStatus" && listType.length > 0)}
                          placeholder="توضیحات"
                          value={value}
                          onInput={onChange}
                          sx={{
                            ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                              padding: "8.5px 14px 8.5px 0px !important",
                            }
                          }}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        ) : (
          <p className="text-center text-large">{ordersServiceGetItem && ordersServiceGetItem.message}</p>
        )}
        <Row className="mt-3">
          {cancelMessage && listType.length > 0 && (
            <Col xs="12" className="text-start">
              <div className=" rounded-3 text-danger bg-light-danger p-3 text-start d-inline-block">
                با انتخاب وضعیت «کنسل شد» این آیتم کنسل می گردد و مبلغ پرداخت شده به کیف پول کاربر واریز می گردد.
              </div>
            </Col>
          )}
          {listType.length > 0 && ordersServiceGetItem && ordersServiceGetItem.succeeded && (
            <Col xs="12" className="text-start mt-3">
              <Button
                variant="success"
                disabled={(timeForSendCod > 0) || isSubmitting}
                type="submit"
                className="mx-1"
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon className="mr-1" />
                {timeForSendCod > 0 ? (
                  <>
                    <span>ذخیره</span>
                    <span className="d-inline-block" style={{ width: "20px" }}>
                      {timeForSendCod}{" "}
                    </span>
                  </>
                ) : (
                  "ذخیره "
                )}
              </Button>
              <Button
                variant="success"
                disabled={(timeForSendCod > 0) || isSubmitting}
                className="mx-1"
                type="submit"
                onClick={() => {
                  setsubmitAndExit(true);
                }}
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <LogoutIcon className="mr-1" />
                {timeForSendCod > 0 ? (
                  <>
                    <span>ذخیره و خروج</span>
                    <span className="d-inline-block" style={{ width: "20px" }}>
                      {timeForSendCod}{" "}
                    </span>
                  </>
                ) : (
                  "ذخیره و خروج "
                )}
              </Button>
            </Col>
          )}
          {props.data.typeOfModal === "DeleteOprationCancelStatus" && hasDeleteCancellation && (
            <Col xs="12" className="text-start mt-3">
              <Button variant="danger" disabled={isSubmitting} type="submit" className="mx-1">
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <DeleteIcon className="mr-1" />
                حذف فرایند
              </Button>
            </Col>
          )}
          {showSupplierErrorMessage && (
            <Col xs="12" className="text-start">
              <div className=" rounded-3 text-danger bg-light-danger p-3 text-start d-inline-block">
                آیتم های انتخابی باید در وضعیت کنسلی یکسان باشند.
              </div>
            </Col>
          )}
        </Row>
      </form>
    </>
  );
}

export default ModalUpdatePersonInItemsCanceled;
